export const PAYMENT_FREQUENCY = {
    TOTAL: '1',
    MONTHLY: '10'
  };
  